import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  contentPaper: {
    marginTop: '24px',
    background: '#fafafa',
  },
  tabPanel: {
    position: 'relative',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  tabPanelShift: {
    width: '100%',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  loader: {
    color: '#DF0C36',
    position: 'fixed',
    left: '50%',
    top: '50%',
  },
  loadingPaper: {
    position: 'absolute',
    zIndex: 2,
    backgroundColor: 'rgba(80, 80, 80, 0.1)',
    height: '100%',
    width: ' 100%',
  },
}));
